import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'

import store from '../store/store';

export default {
    install(Vue) {
        // use a new Vue instance as the interface for Vue components to receive/send SignalR events
        // this way every component can listen to events or send new events using this.$questionHub
        const tasksHub = new Vue();
        Vue.prototype.$tasksHub = tasksHub

        // Provide methods to connect/disconnect from the SignalR hub
        let connection = null;
        let startedPromise = null;
        let manuallyClosed = false;

        const hubUrl = `${store.getters.baseUrl}/tasks-hub`
        Vue.prototype.startTasksSignalR = (jwtToken) => {
            connection = new HubConnectionBuilder()
                .withUrl(hubUrl, jwtToken ? { accessTokenFactory: () => jwtToken } : null)
                .configureLogging(LogLevel.Error)
                .build()

            // Forward hub events through the event, so we can listen for them in the Vue components
            connection.on('TaskAdded', (id, title) => {
                tasksHub.$emit('task-addded', { id, title })
            })

            connection.on('TaskDeleted', (id, title) => {
                tasksHub.$emit('task-deleted', { id, title })
            })

            connection.on('TaskUpdated', (id, title) => {
                tasksHub.$emit('task-updated', { id, title })
            })
            connection.on('SigingAddOrUpdate', (id) => {
                tasksHub.$emit('signing-add-updated', { id })
            })
            connection.on('ToggleClaim', (claimModel) => {
                tasksHub.$emit('toggle-claim', { claimModel })
            })

            // You need to call connection.start() to establish the connection but the client wont handle reconnecting for you!
            // Docs recommend listening onclose and handling it there.
            // This is the simplest of the strategies
            function start() {
                startedPromise = connection.start()
                    .then(e => {
                        console.log('tasks-hub started');
                    })
                    .catch(err => {
                        console.error('Failed to connect with hub', err)
                        return new Promise((resolve, reject) => setTimeout(() => start().then(resolve).catch(reject), 30000))
                    })
                return startedPromise
            }
            connection.onclose(() => {
                if (!manuallyClosed) {
                    start()
                }
            })

            // Start everything
            manuallyClosed = false;
            start();
        }
        Vue.prototype.stopTasksSignalR = () => {
            if (!startedPromise) {
                return;
            }

            manuallyClosed = true
            return startedPromise
                .then(() => connection.stop())
                .then(() => { startedPromise = null })
        }

        // Provide methods for components to send messages back to server
        // Make sure no invocation happens until the connection is established

        // tasksHub.joinToHub = () => {
        //  if (!startedPromise) return

        //  return startedPromise
        //    .then(() => connection.invoke('Join'))
        //    .catch(console.error)
        // }
    }
}
